import { create } from "zustand";

/**
 * 근무자관리 월 셀렉터의 선택월(as-of). 저장(bulk-update) 시 이 월을 valid_from 으로
 * 백엔드에 전달해 "그 달부터 발효"로 기록되게 한다(선택월≠현재월일 때 기존 구간 보존).
 *
 * - page.tsx(roster-management)가 selectedYear/selectedMonth 를 여기에 동기화한다.
 * - saveChangeFullNurseSchema 등 plain 저장 함수가 getState() 로 읽어 URL 에 붙인다.
 * - persist 안 함(뷰 상태). 미설정(null)이면 백엔드가 today 로 폴백.
 */
interface NurseAsOfMonthState {
  year: number | null;
  month: number | null;
  setAsOfMonth: (year: number | null, month: number | null) => void;
}

export const useNurseAsOfMonthStore = create<NurseAsOfMonthState>((set) => ({
  year: null,
  month: null,
  setAsOfMonth: (year, month) => set({ year, month }),
}));
